import PropTypes from 'prop-types'
import {
  branch,
  compose,
  getContext,
  renderNothing,
  withProps
} from 'recompose'
import selectInterestAndPrincipalData from '../selectInterestAndPrincipalData'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool.isRequired
}

const composeWithHomeData = compose(
  selectInterestAndPrincipalData,
  branch(
    ({ shouldCheckNumbers, emptyState }) => emptyState && !shouldCheckNumbers,
    renderNothing
  )
)

const composeWithoutHomeData = withProps(() => ({
  shouldCheckNumbers: false,
  emptyState: false
}))

const HeadlineContainer = compose(
  getContext(contextTypes),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  )
)

export default HeadlineContainer
